var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"align-middle text-center",domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('td',{staticClass:"text-center"},[_c('p',{staticClass:"col-10 mb-0"},[_vm._v(_vm._s(_vm.value))])])])}
var staticRenderFns = []

export { render, staticRenderFns }